import ButtonV2 from 'components/common/ButtonV2';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function DateRangeFilter({ onFilter, dateRange }) {
  const [startDate, setStartDate] = useState(dateRange?.startDate);
  const [endDate, setEndDate] = useState(dateRange?.endDate);

  useEffect(() => {
    setStartDate(dateRange?.startDate);
    setEndDate(dateRange?.endDate);
  }, [dateRange]);

  const handleSubmit = () => {
    onFilter({ startDate, endDate });
  };

  const getIsDisabled = () => {
    if (!startDate && !endDate) {
      return false;
    }
    if (startDate && endDate) {
      return false;
    }
    return true;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <DatePicker
        selected={startDate}
        onChange={(date) => {
          setStartDate(date);
          if (endDate && date > endDate) {
            setEndDate(null);
          }
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        placeholderText="Start Date"
        isClearable
        dateFormat="dd-MM-yyyy"
        wrapperClassName="analytics-datepicker-wrap"
      />
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        placeholderText="End Date"
        isClearable
        dateFormat="dd-MM-yyyy"
        wrapperClassName="analytics-datepicker-wrap"
      />
      <ButtonV2
        color="primary"
        type="button"
        disabled={getIsDisabled()}
        onClick={handleSubmit}
        style={{ whiteSpace: 'nowrap', height: '30px', padding: '0 12px', fontSize: '12px' }}
      >
        Filter
      </ButtonV2>
    </div>
  );
}

export default DateRangeFilter;
